import { ModernHomeCampaigns } from "@app/home/components/modern-home/ModernHomeCampaigns";
import { HallOfFameSection } from "@app/certificates/components/HallOfFameSection";
import { EidAdhaHomeBanner } from "@app/shared/components/EidAdhaHomeBanner";
import { EidHomeBanner } from "@app/shared/components/EidHomeBanner";
import { useFeatureFlag } from "@app/shared/hooks/use-feature-flag";
import { ShortsRailContainer } from "@app/shorts/components/ShortsRail/ShortsRailContainer";
import { GuestHomeResponse, UserHomeResponse } from "@core/home/types";
import type { LeagueSummary } from "@core/league/types";
import { useIsGuest } from "@framework/account/hooks";
import { platformFeaturesAtom } from "@framework/shared/atoms";
import type { TrainingGroundHomeData } from "../utils/training-ground-home";
import { GuestHomePageContent } from "./GuestHomePageContent";
import { UserHomePageContent } from "./UserHomePageContent";

type HomePageContentProps = {
  data: UserHomeResponse | GuestHomeResponse;
  trainingGroundHome?: TrainingGroundHomeData;
  leagueHome?: LeagueSummary;
};

export function HomePageContent({
  data,
  trainingGroundHome,
  leagueHome,
}: HomePageContentProps) {
  const isGuest = useIsGuest();
  const platformFeatures = platformFeaturesAtom.useValue();
  const isEidAdhaEnabled = useFeatureFlag("eidAdha");
  const isEidFetrEnabled = useFeatureFlag("eidFetr");

  const seasonalBanner = isEidAdhaEnabled ? (
    <EidAdhaHomeBanner />
  ) : isEidFetrEnabled ? (
    <EidHomeBanner />
  ) : null;

  return (
    <>
      {seasonalBanner && (
        <div className="container mx-auto px-4 pt-6 sm:px-6 lg:px-8">
          {seasonalBanner}
        </div>
      )}

      {/* Admin banners/sliders (classic home shows the same campaigns). */}
      {(data.campaigns?.banners?.length || data.campaigns?.sliders?.length) ? (
        <div className="container mx-auto px-4 pt-6 sm:px-6 lg:px-8">
          <ModernHomeCampaigns
            banners={data.campaigns?.banners}
            sliders={data.campaigns?.sliders}
          />
        </div>
      ) : null}

      {/* Shorts (الزتونة) rail — SSR'd via the home loader (data.shorts) so
          there's no client-side waterfall. Empty list → rail renders null. */}
      {platformFeatures.shorts === true && (
        <ShortsRailContainer shorts={data.shorts ?? []} limit={12} />
      )}

      {/* «لوحة الشرف»: loads after hydration; renders nothing when empty. */}
      <HallOfFameSection className="container mx-auto px-4 pt-6 sm:px-6 lg:px-8" />

      {/* Route to appropriate component based on user type */}
      {isGuest ? (
        <GuestHomePageContent data={data as GuestHomeResponse} />
      ) : (
        <UserHomePageContent
          data={data as UserHomeResponse}
          trainingGroundHome={trainingGroundHome}
          leagueHome={leagueHome}
        />
      )}
    </>
  );
}
